import { render, staticRenderFns } from "./addPack.vue?vue&type=template&id=37714a80&scoped=true&"
import script from "./addPack.vue?vue&type=script&lang=js&"
export * from "./addPack.vue?vue&type=script&lang=js&"
import style0 from "./addPack.vue?vue&type=style&index=0&id=37714a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37714a80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37714a80')) {
      api.createRecord('37714a80', component.options)
    } else {
      api.reload('37714a80', component.options)
    }
    module.hot.accept("./addPack.vue?vue&type=template&id=37714a80&scoped=true&", function () {
      api.rerender('37714a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/pack/components/addPack.vue"
export default component.exports